export default "__VITE_ASSET__9880cedb__"